<template>
  <common-filter-form :filter="filterForm" :fields="allFields" :default-common-fields="defaultCommonFields" :default-more-fields="defaultMoreFields" config-key="faultTaskFilterConfig" @change="handleFieldChange" @search="handleSearch" @reset="handleReset">
    <template slot="field" slot-scope="{ field, form, reset, labelCol, wrapperCol }">
      <fault-task-filter-form-item
        :form="form"
        :field="field"
        :options="{
          statusList: taskStatus
        }"
        :project-id="projectId"
        :reset="reset"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        @change="handleFieldChange"
      />
    </template>
  </common-filter-form>
</template>

<script>
import { tagList } from '@/api/system/tag';
import { taskStatus } from '@/utils/dictionary';

import CommonFilterForm from '@/components/CommonFilterForm';
import FaultTaskFilterFormItem from '@/pages/event/components/FaultTaskFilterFormItem';

export default {
  name: 'FaultTaskFilterForm',
  components: {
    CommonFilterForm,
    FaultTaskFilterFormItem
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      default: 'task' // work, version
    }
  },
  data() {
    return {
      filterForm: { ...this.value },
      taskStatus,
      projectId: parseInt(this.$route.params.project_id) || 0,
      // 所有可用的筛选项配置
      allFields: [
        { key: 'name', label: '名称/ID', span: 6 },
        { key: 'status', label: '状态', span: 6 },
        { key: 'handlers', label: '处理人', span: 6 },
        { key: 'creator', label: '创建人', span: 6 },
        { key: 'about', label: '与我相关', span: 6 },
        { key: 'dateRange', label: '时间筛选', span: 12, labelSpan: 3, wrapperSpan: 18 }
      ],
      // 默认常用筛选字段
      defaultCommonFields: ['name', 'status', 'handlers'],
      // 默认更多筛选字段
      defaultMoreFields: ['creator', 'about', 'dateRange']
    };
  },
  watch: {
    value: {
      handler(newVal) {
        if (newVal) {
          this.filterForm = { ...newVal };
        }
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    this.getTagList();
  },
  methods: {
    handleFieldChange({ key, value }) {
      this.$set(this.filterForm, key, value);
      this.handleSearch();
    },

    handleSearch() {
      this.$emit('change', this.filterForm);
      this.$emit('update:value', this.filterForm);
    },

    handleReset() {
      // 定义默认的筛选表单值
      const defaultForm = {
        about: 'all',
        end_time: null,
        start_time: null,
        time_filter_key: 'pre_time'
      };
      // 更新表单数据
      this.filterForm = { ...defaultForm };
      this.$emit('reset', this.filterForm);
    },

    getTagList() {
      tagList({ group_code_list: ['task_req_tag', 'coding_task', 'un_coding_task'] }).then(res => {
        res.data.items.forEach(item => {
          const tag = {
            key: item.id,
            value: item.id,
            title: item.name
          };
          switch (item.group_code) {
            case 'task_req_tag':
              this.tagData.push(item);
              break;
            case 'coding_task':
              this.objectiveData[0].children.push(tag);
              break;
            case 'un_coding_task':
              this.objectiveData[1].children.push(tag);
              break;
            default:
              break;
          }
        });
      });
    }
  }
};
</script>

<style lang="less" scoped>
.task-filter-form {
  :deep(.ant-form-item) {
    margin-bottom: 0px;

    .ant-form-item-label {
      text-align: right;
      color: #495057;
      padding-right: 8px;
    }
  }
}
</style>
